<template>
    <div class="admin-list-generator-items"
         v-if="config.listGenerator">

        <b-btn variant="success" size="sm" class="float-right mb-3"
               @click="addList()">
            Add List
        </b-btn>

        <div style="clear:both"></div>

        <draggable class="dragArea"
                   v-model="config.listGenerator.lists">
            <b-row class="my-2" v-for="(list, listIndex) in config.listGenerator.lists">
                <b-col>
                    <b-card no-body class="mb-3">
                        <b-card-header v-b-toggle="`list_${listIndex}`">
                            <open-icon name="resize-height"
                                       class="drag-handle"></open-icon>
                            <open-icon name="chevron-bottom"
                                       v-if="list.visible"></open-icon>
                            <open-icon name="chevron-right"
                                       v-if="!list.visible"></open-icon>

                            {{ list.title }}

                            <div class="float-right">
                                <b-form-checkbox v-model="list.enabled" class="d-inline mr-3">
                                    Enabled
                                </b-form-checkbox>
                                <b-btn variant="default" size="sm" class="float-right"
                                       @click="deleteList(list)">
                                    <open-icon
                                        name="delete"></open-icon>
                                </b-btn>
                            </div>

                        </b-card-header>
                        <b-collapse :id="`list_${listIndex}`"
                                    v-model="list.visible">
                            <b-card-body>

                                <b-form-group label="List Title">
                                    <b-form-input type="text" v-model="list.title"></b-form-input>
                                </b-form-group>

                                <b-form-group label="List Description">
                                    <b-form-input type="text" v-model="list.description"></b-form-input>
                                </b-form-group>

                                <b-form-group label="List Items (add each item on a new line)">
                                    <b-form-textarea rows="10" v-model="list.text" placeholder="Add list items..."></b-form-textarea>
                                </b-form-group>

                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>
            </b-row>
        </draggable>

    </div>
</template>

<script>

import Vue from 'vue'
import draggable from 'vuedraggable'

export default Vue.extend({
    name: 'AdminListGeneratorItems',
    components: {
        draggable
    },
    computed: {
        config() {
            return this.$store.state.config
        },
    },
    methods: {
        addList() {
            this.config.listGenerator.lists.unshift(
                {title: 'New List', description: '', text: '', enabled: true, visible: true}
            )
        },
        deleteList(list) {
            this.config.listGenerator.lists = _.without(this.config.listGenerator.lists, list)
        }
    }
})

</script>
